import { IAppState, statePropName } from './slice';
export interface IState {
  [statePropName]: IAppState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getAppState = (state: IState) => state[statePropName];

export const isAppReady = (state: IState) => getAppState(state).ready;

export const getArticles = (state: IState) => getAppState(state).articles;

export const getError = (state: IState) => getAppState(state).error;

export const getView = (state: IState) => getAppState(state).view;

export const getCountries = (state: IState) => getAppState(state).countries;

export const getMostCommonList = (state: IState) => getAppState(state).mostCommon;
